import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import { IRole } from "../../../models/role/response";
import { getUserStatus } from "../../../models/user/enum";
import EndPoints from "../../../services/end-points";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import UserContext from "../../../context/user/context";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { useLocation } from "react-router-dom";

interface IProps { }

const UserFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(UserContext);
  const [roles, setRoles] = useState<IRole[]>([]);
  const [rolesLoading, setRolesLoading] = useState<boolean>(false);
  const { direction } = useContext(AppContext);
  const statuses = [1, 2];

  const location = useLocation();
  const [initialValues, setInitialValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const filters = getFiltersFromURL();

    const initialValuesObj = {};
    filters.forEach((f) => {
      initialValuesObj[f.name] = f.value;
    });

    setInitialValues(initialValuesObj);
  }, [location.search]); useEffect(() => {
    const getRoles = async () => {
      try {
        const { data } = await EndPoints.role.getAllroles({
          light: true,
          perPage: -1,
        });
        setRoles(data.data);
        setRolesLoading(false);
      } catch (error) {
      } finally {
        setRolesLoading(false);
      }
    };
    getRoles();
  }, [direction]);
  return (
    <Form
      formId="user-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
            data?.role
              ? {
                name: "role",
                value: data.role,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statuses.map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="role"
            label={`${t("role")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              loading: rolesLoading,
              options: roles?.map((role, index) => {
                return {
                  label: role?.name as string,
                  value: role?.id as number,
                };
              }),
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default UserFilter;
